import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function SubscriptionRequiredPage() {
  const { user, xTranslator, refreshAccess } = useAuth();
  const status = xTranslator?.status;
  const [retrying, setRetrying] = React.useState(false);

  if (xTranslator?.unavailable) {
    return (
      <div className="max-w-xl">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          Subscription could not be checked
        </h1>
        <p className="mt-3 text-gray-600 dark:text-gray-400 leading-relaxed">
          You are signed in as {user?.email}, but the X-Translator subscription
          status could not be loaded. Try again in a moment.
        </p>
        <button
          type="button"
          disabled={retrying}
          onClick={async () => {
            setRetrying(true);
            try {
              await refreshAccess();
            } finally {
              setRetrying(false);
            }
          }}
          className="mt-6 rounded-lg bg-sepm-primary px-4 py-2 text-sm font-semibold text-white disabled:opacity-60"
        >
          {retrying ? "Checking…" : "Try again"}
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-xl">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
        X-Translator subscription required
      </h1>
      <p className="mt-3 text-gray-600 dark:text-gray-400 leading-relaxed">
        The X-Translator user manual is available to accounts with an active
        X-Translator subscription. You are signed in as {user?.email}.
      </p>
      {status ? (
        <p className="mt-3 text-sm text-gray-500 dark:text-gray-500">
          Current subscription status: {status}.
        </p>
      ) : (
        <p className="mt-3 text-sm text-gray-500 dark:text-gray-500">
          No active X-Translator subscription was found for this account.
        </p>
      )}
      <div className="mt-6 flex flex-wrap gap-3">
        <a
          href="https://sepm.ch/pricing"
          className="inline-flex items-center rounded-lg bg-sepm-primary px-4 py-2 text-sm font-semibold text-white"
        >
          View X-Translator plans
        </a>
        <Link
          to="/"
          className="inline-flex items-center rounded-lg border border-gray-300 dark:border-gray-600 px-4 py-2 text-sm font-semibold"
        >
          Back to documentation
        </Link>
      </div>
    </div>
  );
}
